import { connectMediaStore } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getGallectionStreamId } from '../helpers';
import { getCurrentMediaSource, getGallections } from '../selectors';
import { fetchMoreGallections } from '../actions';
var mapStateToProps = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource);
    var gallections = getGallections(state);
    return {
        gallections: gallections,
        hasMoreGallections: selectors.hasMore(state, streamId),
        isFetchingGallections: selectors.isFetching(state, streamId),
        isGallectionStreamInitialized: selectors.isInitialized(state, streamId),
    };
};
var mapDispatchToProps = {
    fetchMoreGallections: fetchMoreGallections,
};
export default connectMediaStore(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=withGallections.js.map